import { nullish } from '../../../../shared/types/nullish.ts';
import { ControlValues } from '../../../../shared/types/spc.ts';
import { Batch, Operation } from '../../../types/sharedTypeImpl.ts';
import { MeasurementGraphSettings } from '../settings/measurementGraphSettings.ts';
import { getMetaData, MetaData } from './getMetaData.ts';
import { BatchStart, prepareBatchStarts } from './prepareBatchStarts.ts';
import { MGraphMeasurement, PreparedMeasurement, prepareMeasurements } from './prepareMeasurements.ts';
import { OperationMarker, prepareOperationMarkers } from './prepareOperationMarkers.ts';


export interface PreparedData {
    metaData: MetaData;
    measurements: PreparedMeasurement[];
    batchStarts: BatchStart[] | null;
    operationMarkers: OperationMarker[] | null;
}

export function prepareData(
    measurements: MGraphMeasurement[],
    controlValues: ControlValues,
    settings: MeasurementGraphSettings,
    batches: Batch[] | nullish,
    operations: Operation[] | nullish,
): PreparedData {
    const preparedMeasurements = prepareMeasurements(measurements);
    const metaData = getMetaData(measurements, controlValues, settings);
    const batchStarts = prepareBatchStarts(measurements, batches);
    const operationMarkers = prepareOperationMarkers(measurements, operations);

    return {
        metaData,
        measurements: preparedMeasurements,
        batchStarts,
        operationMarkers,
    };
}